export default "__VITE_ASSET__Blcwqtxl__"